"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _coreFunctionalTabs = require("@legacy-vfuk/core-functional-tabs");
var _coreIcon = _interopRequireDefault(require("@legacy-vfuk/core-icon"));
var _coreBaseProps = require("@legacy-vfuk/core-base-props");
var Styled = _interopRequireWildcard(require("./styles/TabTitle.style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var TabTitle = function TabTitle(_ref) {
  var isActiveTab = _ref.isActiveTab,
    tabId = _ref.tabId,
    tabWidth = _ref.tabWidth,
    text = _ref.text,
    appearance = _ref.appearance,
    inverse = _ref.inverse,
    isOverflowMenuOpen = _ref.isOverflowMenuOpen,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    onKeyPress = _ref.onKeyPress,
    overflowActive = _ref.overflowActive,
    dataSelectorPrefix = _ref.dataSelectorPrefix,
    localTheme = _ref.localTheme;
  return /*#__PURE__*/_react["default"].createElement(Styled.TabContainer, {
    role: "presentation",
    overflowActive: overflowActive,
    tabWidth: tabWidth,
    onClick: onClick,
    onFocus: onFocus,
    onKeyPress: onKeyPress,
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix)
  }, /*#__PURE__*/_react["default"].createElement(_coreFunctionalTabs.FunctionalTab, {
    tabId: tabId,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'functional-tab')
  }, /*#__PURE__*/_react["default"].createElement(Styled.TabTitle, {
    isActiveTab: isActiveTab,
    appearance: appearance,
    inverse: inverse,
    tabWidth: tabWidth,
    "data-text": text,
    tabsTheme: localTheme,
    overflowActive: overflowActive,
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'tab-title')
  }, text, overflowActive && /*#__PURE__*/_react["default"].createElement(Styled.IconContainer, {
    isOverflowMenuOpen: isOverflowMenuOpen
  }, /*#__PURE__*/_react["default"].createElement(_coreIcon["default"], {
    inverse: inverse,
    name: "chevron-down",
    size: 1,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'chevron-icon')
  })))));
};
TabTitle.displayName = "TabTitle";
var _default = TabTitle;
exports["default"] = _default;
//# sourceMappingURL=TabTitle.js.map